"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _layout = require("../layout");

var _utils = require("../utils");

var _constants = require("./constants");

var _core = require("@emotion/core");

var _excluded = ["children"];

var ModalBody = function ModalBody(_ref) {
  var children = _ref.children,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return (0, _core.jsx)(_layout.View, (0, _extends2.default)({
    padding: _constants.BODY_PADDING
  }, (0, _utils.pickDataProps)(forwardedProps)), children);
};

var _default = (0, _utils.composeStencilComponent)({
  baseComponent: ModalBody,
  description: 'Body of the modal which contains the content.',
  displayName: 'ModalBody',
  propTypes: {
    children: _stencilReactDesc.PropTypes.node.isRequired.description('Content to display in the modal body.')
  }
});

exports.default = _default;